import BookSession from '../../../guidanceSessions/components/BookSession';

export default function BookSessionScreen() {
    return <BookSession />;
}
